module.exports = __webpack_public_path__ + "static/media/logos_50h_annexebc.ba5fe0e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_annexebc.jpg
// module id = 220
// module chunks = 0